import React from 'react';
import PlayListSearchContainer from 'containers/PlayListSearchContainer/PlayListSearchContainer';

export default function PlayListSearchPage() {
    return (
        <PlayListSearchContainer />
    )
}
